import { EDMDocumentViewer } from '@usb-edm/react-document-viewer';
import { EDMSideModal } from '@usb-edm/react-side-modal';
import React, { useEffect, useRef, useState } from 'react';
import {
  Link,
  useLocation,
} from 'react-router-dom';
import PropTypes from 'prop-types';

import { USBCheckbox } from '@usb-shield/components-react/dist/cjs'
import callApi from '../../components/utilities/callApi';
import {
  saveAsFile,
  getQS,
  previewFile,
} from '../../components/utilities/Utils';
import { endpoints } from '../../../config/connections';
import { USBIconShow, USBIconClose } from '@usb-shield/react-icons';
import greenTick from '../../../assets/img/green-tick.svg';
import greyCheck from '../../../assets/img/grey_check.png';
import threeDots from '../../../assets/img/threedots.png';
import useUserRole from '../../components/Hooks/use-UserRole';

const getFileListsfromSessionStorage = () => {
  let fileLists = [];
  if (sessionStorage.getItem('fileNetIdLists')) {
    fileLists = JSON.parse(sessionStorage.getItem('fileNetIdLists'));
  }
  return fileLists;
};

const removeFileListSessionStorage = (name) => {
  let fileLists = getFileListsfromSessionStorage();
  if (fileLists.length > 0) {
    console.log('removing');
    const index = fileLists.indexOf(name);
    if (index > -1) {
      fileLists.splice(index, 1);
    }
    sessionStorage.setItem('fileNetIdLists', JSON.stringify(fileLists));
  } else {
    console.log('deleting session');
    sessionStorage.removeItem('fileNetIdLists');
    fileLists = [];
  }
};

const appendFileListSessionStorage = (name) => {
  console.log('appending', name);
  const fileLists = getFileListsfromSessionStorage();

  if (!(fileLists.indexOf(name) > -1)) {
    fileLists.push(name);
  }
  sessionStorage.setItem('fileNetIdLists', JSON.stringify(fileLists));
};

const getDownloadListsfromSessionStorage = () => {
  let fileLists = [];
  if (sessionStorage.getItem('fileDownloadIdLists')) {
    fileLists = JSON.parse(sessionStorage.getItem('fileDownloadIdLists'));
  }
  return fileLists;
};

const removeDownloadListSessionStorage = (
  id,
  setDownloadEnabled,
  count,
  setCount
) => {
  if (id != null) {
    let fileLists = getDownloadListsfromSessionStorage();
    if (fileLists.length > 1) {
      const index = fileLists.indexOf(id);
      if (index > -1) {
        fileLists.splice(index, 1);
      }
      const temp = fileLists.length;
      setCount(temp);
      sessionStorage.setItem('fileDownloadIdLists', JSON.stringify(fileLists));
    } else {
      const temp = fileLists.length;
      setCount(temp - 1);
      setDownloadEnabled(false);
      sessionStorage.removeItem('fileDownloadIdLists');
      fileLists = [];
    }
  }

};

const appendDownloadListSessionStorage = (
  id,
  setDownloadEnabled,
  count,
  setCount
) => {
  if (id != null) {
    const fileLists = getDownloadListsfromSessionStorage();
    if (fileLists.indexOf(id) == -1) {
      fileLists.push(id);
      const temp = fileLists.length;
      setCount(temp);
    }
    setDownloadEnabled(true);
    sessionStorage.setItem('fileDownloadIdLists', JSON.stringify(fileLists));
  }
};

const isPresentInStorage = (id, setActionsDrop) => {
  const fileLists = getDownloadListsfromSessionStorage();
  let checked = false;
  if (fileLists.length >= 1 && id != null) {
    const index = fileLists.indexOf(id);
    if (index > -1) {
      checked = true;
    }
  }
  setActionsDrop('0');

  return checked;
};

export const selectDownloadFile = (
  items,
  setActionsDrop,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  reportingDetailsData,
  setLoading,
  selectAll,
  setSelectAll,
  setDownloadEnabled,
  count,
  setCount,
  index
) => {
  setLoading(true);
  const newData = reportingDetailsData;
  items.forEach((item, i) => {
    if (item.downloadId != null && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
      const tempIndex = index == -1 ? i : index;
      if (index == -1 && item.downloadId && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
        if (!selectAll && item.downloadId && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
          appendDownloadListSessionStorage(
            item.downloadId,
            setDownloadEnabled,
            count,
            setCount
          );
          newData[tempIndex].checked = true;
        } else {
          if (isPresentInStorage(item.downloadId, setActionsDrop)) {
            setSelectAll(false)
            removeDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = false;
          } else {
            appendDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = true;
          }
        }        // individual checkox is clicked
      } else {
        if (selectAll && item.downloadId && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
          // select all option is checked
          if (isPresentInStorage(item.downloadId, setActionsDrop)) {
            setSelectAll(false);
            removeDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = false;
          } else {
            appendDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = true;
          }
        } else {
          if (isPresentInStorage(item.downloadId, setActionsDrop)) {
            removeDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = false;
          } else {
            if (
              getDownloadListsfromSessionStorage().length ==
              reportingDetailsData.length - 1
            ) {
              setSelectAll(true);
            }
            appendDownloadListSessionStorage(
              item.downloadId,
              setDownloadEnabled,
              count,
              setCount
            );
            newData[tempIndex].checked = true;
          }
        }
      }
    }
  });
  // console.log(newData);
  setActionsDrop('0');
  getDocumentListingNoAPI(setReportingDetailsData, newData);

  setTimeout(() => {
    setLoading(false);
  }, 500);
};

export const selectMarkedAsFinal = (
  items,
  reportingDetailsData,
  setActionsDrop,
  getDocumentListing,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  renamedFlag,
  setLoading,
  setIsDirty,
  selectMarkfinal,
  setSelectMarkfinal,
  indexValue,
) => {
  setLoading(true);
  const newData = reportingDetailsData;
  items.forEach((item, i) => {
    if (item.id !== null && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
      const tempIndex = indexValue == -1 ? i : indexValue;
      if (indexValue == -1 && item.id && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
        if (!selectMarkfinal && item.id && (item.edmStatus !== 'Success EDM' && item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) {
          appendFileListSessionStorage(item.id)
          newData[tempIndex].MarkedasFinalValue = true;
          setReportingDetailsData(newData)
        }
        else {
          if (selectMarkfinal && item.id && (item.edmStatus !== 'Success EDM' && item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed') || isPresentInStorage(item.id, setActionsDrop)) {
            setSelectMarkfinal(false);
            removeFileListSessionStorage(item.id);
            newData[tempIndex].MarkedasFinalValue = false;
            setReportingDetailsData(newData)
          }
        }
      }
    }
  });
  setActionsDrop('0');
  getDocumentListingNoAPI(setReportingDetailsData, newData);
  setTimeout(() => {
    setLoading(false);
  }, 500);
};

export const markFinal = (
  final,
  item,
  setActionsDrop,
  getDocumentListing,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  reportingDetailsData,
  setLoading,
  setIsDirty,
  selectMarkfinal,
  setSelectMarkfinal,
  showWarning
) => {
  setIsDirty(true);
  showWarning()
  if (item.MarkedasFinalValue === false) {
    Object.assign(item, { MarkedasFinalValue: true });
    appendFileListSessionStorage(item.id);
    if (reportingDetailsData.filter((item) => item.MarkedasFinalValue === false).length === 0) {
      setSelectMarkfinal(true);
    }
  } else if (item.MarkedasFinalValue === true || isPresentInStorage(item.id, setActionsDrop)) {
    Object.assign(item, { MarkedasFinalValue: false });
    removeFileListSessionStorage(item.id);
    setSelectMarkfinal(false)
  }
  setActionsDrop('0');
  setTimeout(() => {
    setLoading(false);
  }, 500);
};


export const markAsFinal = (
  id,
  reportingDetailsData,
  setActionsDrop,
  getDocumentListing,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  renamedFlag,
  setFailedFlag,
  setMessageContent,
  setSuccessFlag,
  setLoading,
  setIsDirty,
  selectMarkfinal,
  setSelectMarkfinal,
  showWarning
) => {
  setSuccessFlag(false);
  setFailedFlag(false);
  setLoading(true);
  reportingDetailsData.forEach((item) => {
    if (item.MarkedasFinalValue === false && item.id === id) {
      markFinal(
        true,
        item,
        setActionsDrop,
        getDocumentListing,
        getDocumentListingNoAPI,
        setReportingDetailsData,
        reportingDetailsData,
        setLoading,
        setIsDirty,
        selectMarkfinal,
        setSelectMarkfinal,
        showWarning
      );
    } else if (item.MarkedasFinalValue === true && item.id === id) {
      markFinal(
        false,
        item,
        setActionsDrop,
        getDocumentListing,
        getDocumentListingNoAPI,
        setReportingDetailsData,
        reportingDetailsData,
        setLoading,
        setIsDirty,
        selectMarkfinal,
        setSelectMarkfinal,
        showWarning
      );
    }
  });
};

export const toggleAccordion = (id, openedAccordion, setOpenedAccordion) => {
  if (openedAccordion === id) {
    setOpenedAccordion(0);
  } else {
    setOpenedAccordion(id);
  }
};

export const showActionsDropdown = (id, actionsDrop, setActionsDrop) => {
  if (actionsDrop !== id) {
    setActionsDrop(id);
  } else {
    setActionsDrop('0');
  }
};

export const handleKeyDown = (event, id, actionsDrop, setActionsDrop) => {
  if (event.keyCode === 13 || event.keyCode === 32) {
    showActionsDropdown(id, actionsDrop, setActionsDrop);
  }
  if (event.keyCode === 27) {
    setActionsDrop('0');
  }
};

export const threeDotKeyDown = (event, setActionsDrop) => {
  if (event.keyCode === 27) {
    setActionsDrop('0');
  }
};

export const versionKeyDown = (
  event,
  id,
  openedAccordion,
  setOpenedAccordion
) => {
  if (event.keyCode === 13 || event.keyCode === 32) {
    toggleAccordion(id, openedAccordion, setOpenedAccordion);
  }
  if (event.keyCode === 27) {
    setOpenedAccordion(0);
  }
};

export const downloadDocument = (
  id,
  setLoading,
  setActionsDrop,
  setFileDownload,
  getDocumentListing,
  setReportingDetailsData,
  setMessageContent,
  setFailedFlag
) => {
  setLoading(true);
  setFileDownload(true);

  const apiURL = `${endpoints.api}/document-management/file-download/v1/files?fileIdList=${id}`;
  callApi
    .getApiData(apiURL)
    .then((result) => {
      getDocumentListing(setReportingDetailsData);
      saveAsFile(
        JSON.parse(result.data[0].binaryContent).binary,
        JSON.parse(result.data[0].binaryContent).fileName
      );

      setLoading(false);
      setActionsDrop('0');
    })
    .catch((error) => {
      if (error?.response?.data?.statusCode !== 200) {
        setMessageContent(error?.response?.data?.errorMessage);

        setFailedFlag(true);
      }
      setLoading(false);
      setActionsDrop('0');
    });
};

export const confirmReplace = (
  setErrorModal,
  setLegalHold,
  setErrorModalTxt,
  setErrorModalTitle
) => {
  setErrorModal(true);
  setLegalHold(true);
  const contentTxt = (
    <div>
      For retention purposes, this file can&apos;t be replaced right now.
    </div>
  );
  setErrorModalTxt(contentTxt);
  setErrorModalTitle('Unable to replace file.');
};

export const replaceFile = (
  event,
  item,
  setSuccessFlag,
  setFailedFlag,
  setMessageContent,
  setLoading,
  setActionsDrop,
  getDocumentListing,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  reportingDetailsData,
  setSelectMarkfinal,
  setIsDirty,
  showWarning,
  requirementResults
) => {
  setSuccessFlag(false);
  setFailedFlag(false);


  const file = event.target.files[0];
  const fileName = file?.name || '';
  const invalidCharRegex = /[\/:*?"<>|&]/;
  if (invalidCharRegex.test(fileName)) {
    setFailedFlag(true);
    setMessageContent(
      <div className='notification-error'>
        <div>
          The file name contains invalid characters like  <strong>@ # $ % &amp; * ! ^ ~ + = {'{'} {'}'} {'['} {']'} | \ : ; &quot; &lt; &gt; ? /</strong> and cannot be uploaded. Please rename the file and try again.
        </div>
        <div>• The file "{fileName}" contains invalid characters.</div>
      </div>
    );
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setTimeout(() => { setFailedFlag(false); }, 5000);
    return false;
  }

  const acceptedFileExtentions = [
    'pdf',
    'xls',
    'xlsx',
    'doc',
    'docx',
    'xml',
    'jpeg',
    'jpg',
  ];
  const formData = new FormData();
  formData.append('reqId', getQS('id'));
  formData.append('file', event.target.files[0]);
  // formData.append('areaToStore ', 'Temporary')
  formData.append('user ', sessionStorage.getItem('loggedUser'));
  const ext = event.target.value.split('.').pop();
  if (event.target.files[0].size > 104857600) {
    setFailedFlag(true);
    setMessageContent(
      `We were unable to upload your document. Make sure your file size is less than 100MB and try again.`
    );
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setFailedFlag(false);
    }, 5000);
    return false;
  }
  if (acceptedFileExtentions.indexOf(ext.toLowerCase()) < 0) {
    setFailedFlag(true);
    setMessageContent(
      `We were unable to upload the document. Make sure your file is in a supported format (${acceptedFileExtentions.join(
        ','
      )}) and try again.`
    );
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setFailedFlag(false);
    }, 5000);
    return false;
  }
  const newFileName = event.target.files[0]?.name;
  const duplicate = reportingDetailsData.some(
    (doc) =>
      doc.id !== item.id &&
      (doc.title?.toLowerCase() === newFileName.toLowerCase() ||
        doc.fullName?.toLowerCase() === newFileName.toLowerCase())
  );
  if (duplicate) {
    setFailedFlag(true);
    setMessageContent(`Unable to replace document. ${newFileName} is already uploaded`);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setFailedFlag(false);
    }, 5000);
    return false;
  }
  const userId = sessionStorage.getItem('loggedUser');
  const docId = getQS('id');
  const filenetId = item.downloadId ? item.downloadId : item.id;
  setLoading(true);
  let url = '';
  if (["syndicated deal tax return", "wire request", "invoice request"].includes((requirementResults?.category + '').toLowerCase())) {
    url = `${endpoints.api}/document-management/file-upload/v1/users/userId/documents/${docId}/files/perm/fileReplace?fileId=${filenetId}`;
  } else {
    url = `${endpoints.api}/document-management/file-upload/v1/users/userId/documents/${docId}/files/fileReplace?fileId=${filenetId}`;
  }
  return callApi
    .postApiUpload(url, formData)
    .then((response) => {
      if (response.status === 200) {
        getDocumentListing(setReportingDetailsData);
        setSuccessFlag(true);
        setMessageContent(`You’ve successfully uploaded your document.`);
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
        setIsDirty(true);
        showWarning()
        setTimeout(() => {
          setSuccessFlag(false);
          setSelectMarkfinal(false);
        }, 5000);
      } else {
        // console.log('upload failed')
      }
      setLoading(false);
      //sessionStorage.removeItem('fileNetIdLists');
      setActionsDrop('0');
    })
    .catch(() => {
      // console.log(error)
      setLoading(false);
      setActionsDrop('0');
    });
}

export const handleKeyDownReplace = (e, replaceInputFile) => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    e.preventDefault();
    replaceInputFile.click();
  }
  return false;
};

export const editFileName = (
  id,
  setLoading,
  getDocumentListing,
  getDocumentListingNoAPI,
  setReportingDetailsData,
  reportingDetailsData,
  setCloseRenameModal,
  setRenamedTextReceived,
  setCurrentFilenetId,
  renameFocus
) => {
  setLoading(true);
  const url = `${endpoints.api}/document-management/file-upload/v1/files/getFileRename?fileId=${id}`;
  callApi
    .getApiDataRequirement(url)
    .then((response) => {
      if (response.status === 200) {
        setCurrentFilenetId(id);
        setCloseRenameModal(true);
        setRenamedTextReceived(response.data);
        setLoading(false);
      }
    })
    .catch(() => {
      setLoading(false);
      // console.log(error)
    });
  renameFocus.current.focus();
};

export const confirmDelete = (
  data,
  setDeleteId,
  setErrorModal,
  setErrorModalTxt,
  setErrorModalTitle,
  setLegalHold,
  setCount,
  count,
  setDownloadEnabled
) => {
  setDeleteId(data.id);
  setErrorModal(true);
  removeDownloadListSessionStorage(data.id, setDownloadEnabled, count, setCount)
  if (data.legalHoldFlag === 'true') {
    setLegalHold(true);
    const contentTxt = (
      <div>
        For retention purposes, this file can&apos;t be deleted right now.
      </div>
    );
    setErrorModalTxt(contentTxt);
    setErrorModalTitle('Unable to delete file.');
  } else {
    setLegalHold(false);
    setErrorModalTxt('You can’t undo this action');
    setErrorModalTitle('Are you sure you want to delete this document?');
  }
};

// Exported helpers for package.json analyzer features

export function isRecent(dateStr) {
  if (!dateStr || dateStr === '-') return false;
  const date = new Date(dateStr);
  const now = new Date();
  const diff = now - date;
  return diff < 7 * 24 * 60 * 60 * 1000;
}

export function sortPackagesByDate(packages) {
  return [...packages].sort((a, b) => {
    const dateA = a.latestReleaseDate && a.latestReleaseDate !== '-' ? new Date(a.latestReleaseDate) : new Date(0);
    const dateB = b.latestReleaseDate && b.latestReleaseDate !== '-' ? new Date(b.latestReleaseDate) : new Date(0);
    return dateB - dateA;
  });
}

export function isCommercialLicense(license) {
  if (!license) return false;
  const allowed = ['MIT', 'Apache-2.0', 'BSD-2-Clause', 'BSD-3-Clause', 'ISC', 'Unlicense', 'CC0-1.0'];
  return allowed.includes(license);
}

export function isDeprecated(pkg) {
  return pkg.deprecated === true || (typeof pkg.deprecated === 'string' && pkg.deprecated.length > 0);
}

export function estimateBundleSize(pkgName) {
  const knownSizes = {
    react: 6,
    'react-dom': 110,
    lodash: 70,
    axios: 18,
    moment: 60,
    'date-fns': 20,
    'react-router-dom': 30,
    redux: 2,
    'redux-thunk': 1,
    rxjs: 25,
    'styled-components': 15,
    'prop-types': 5,
    'core-js': 80,
    uuid: 2,
    immer: 8,
    classnames: 1,
    'react-scripts': 120,
    typescript: 80,
    eslint: 60,
    webpack: 60,
    'babel-core': 40,
    'babel-loader': 10,
    'babel-preset-react-app': 10,
    'usb-shield': 20,
    'usb-edm': 20,
    'usb-sharedauth': 20,
    'usb-ui-tools': 20,
    'usb-ui-servicing': 20,
    'usb-inner-src': 20,
    'usb-corporate-commons': 20,
  };
  return knownSizes[pkgName] || 0;
}

const DocumentList = ({
  setLoading,
  reportingDetailsData,
  openedAccordion,
  setOpenedAccordion,
  employee,
  actionsDrop,
  setActionsDrop,
  getDocumentListing,
  getDocumentListingNoAPI,
  requirementResults,
  setSuccessFlag,
  setFailedFlag,
  setMessageContent,
  setDownloadEnabled,
  count,
  setCount,
  setDeleteId,
  setErrorModal,
  setErrorModalTxt,
  setErrorModalTitle,
  setReportingDetailsData,
  setCloseRenameModal,
  setRenamedTextReceived,
  setCurrentFilenetId,
  setLegalHold,
  setFileDownload,
  selectAll,
  setSelectAll,
  selectMarkfinal,
  setSelectMarkfinal,
  setIsDirty,
  removeWarning,
  showWarning,
  setDisableSubmit,
  isMarkAsFinalAllowed,
  isDeleteAllowed,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [binaryData, setBinaryData] = useState(null);
  const [fileName, setFilename] = useState(null);
 
  const preview = (id, setLoading, setActionsDrop) => {

    window.open(`/document-viewer?url=` + id)

  };

  let replaceInputFile = '';
  const handleClickOutside = (event) => {
    if (
      event.srcElement.className !== 'threedots-anchor' &&
      event.srcElement.className !== 'threedots-upload' &&
      (event.srcElement?.id !== 'defaultFor' || event.srcElement?.target?.localName == 'input')
    ) {
      setActionsDrop('0');
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
  }, []);

  useEffect(() => {
    ["syndicated deal tax return", "wire request", "invoice request"].includes((requirementResults?.category + '').toLowerCase()) ?
      setDisableSubmit(reportingDetailsData.filter(item =>
        item.edmStatus == 'Success EDM' ||
        item.edmStatus == 'Success FileNet' ||
        item.edmStatus == 'Success'
      ).length <= 0) :

      setDisableSubmit(reportingDetailsData.filter(item =>
        item.edmStatus == 'Success Temp' ||
        item.edmStatus == 'Success'
      ).length <= 0)

  }, [reportingDetailsData])


  const renameFocus = useRef(null);
  const toolbar = {
    // print: true,
    // open: true,
    // download: true,
    // delete: false,
    // rotate: true
    // zoomInOut: true,
    // zoomSelect: true,
  };
  const location = useLocation();
  const tempUserRole = useUserRole();
  // const Navigate = useNavigate();
  return (
    <div>
      {reportingDetailsData && reportingDetailsData.length === 0 ? (
        ''
      ) : (
        <div className={tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? "container-header" : "container-header-external"}>
          {/* <div className="filedownload title">Select All</div> */}
          <div className="selectAllHeaderG grid-title" data-testid="chck-box" style={!((reportingDetailsData.downloadId) || (reportingDetailsData.edmStatus !== 'SentToEDM' && reportingDetailsData.edmStatus !== 'SentToEdmTemp' && reportingDetailsData.edmStatus !== 'Failed Temp' && reportingDetailsData.edmStatus !== 'Failed')) ? { pointerEvents: 'none', cursor: 'not-allowed', opacity: 0.5, } : {}}>
            <USBCheckbox
              handleChange={(event) => {
                if (event?.target?.checked) {
                  setSelectAll(true);
                } else {
                  setSelectAll(false);
                }
                selectDownloadFile(
                  reportingDetailsData,
                  setActionsDrop,
                  getDocumentListingNoAPI,
                  setReportingDetailsData,
                  reportingDetailsData,
                  setLoading,
                  selectAll,
                  setSelectAll,
                  setDownloadEnabled,
                  count,
                  setCount,
                  -1 // indicates select all
                );
              }}
              // initIsDisabled={
              //   ((reportingDetailsData.downloadId) || (reportingDetailsData.edmStatus !== 'SentToEDM' && reportingDetailsData.edmStatus !== 'SentToEdmTemp' && reportingDetailsData.edmStatus !== 'Failed Temp' && reportingDetailsData.edmStatus !== 'Failed')) ? false : true
              // }
              addClasses="grid-title"
              subLabel=""
              initIsChecked={selectAll}
              labelText="Select All"
              ariaLabelledBy="select-all"
            />
          </div>
          <div className={tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? "fileNameHeaderG grid-title" : "fileNameHeaderG-external grid-title"}>File name</div>
          {tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? (<div className="documentTitleHeaderG grid-title">Document Title</div>) : ''}
          <div className="uploadedOnHeaderG grid-title">Uploaded On </div>
          <div className="uploadedByHeaderG grid-title">Uploaded By</div>
          <div className="finalVersionHeaderG" style={((reportingDetailsData.downloadId) ||
            (reportingDetailsData.permanentLocationFlag ||
              reportingDetailsData.edmStatus == 'SentToEDM' ||
              reportingDetailsData.edmStatus == 'SentToEdmTemp' ||
              reportingDetailsData.edmStatus == 'Failed Temp' ||
              reportingDetailsData.edmStatus == 'Failed') || (["invoice request", "wire request", "syndicated deal tax return"].includes((requirementResults?.category + '').toLowerCase()))) ? { pointerEvents: 'none', cursor: 'not-allowed', opacity: 0.5, } : {}}>
            {tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? (<div>
              {isMarkAsFinalAllowed ? <USBCheckbox
                addClasses="grid-title"
                handleChange={(event) => {
                  if (event?.target?.checked) {
                    setSelectMarkfinal(true);
                    setIsDirty(true);
                    showWarning();
                  } else {
                    setSelectMarkfinal(false);
                    setIsDirty(false);
                    removeWarning();
                  }

                  selectMarkedAsFinal(
                    reportingDetailsData,
                    reportingDetailsData,
                    setActionsDrop,
                    getDocumentListing,
                    getDocumentListingNoAPI,
                    setReportingDetailsData,
                    reportingDetailsData.renamedFlag,
                    setLoading,
                    setIsDirty,
                    selectMarkfinal,
                    setSelectMarkfinal,
                    -1  //indicates select all
                  )
                }}
                initIsChecked={selectMarkfinal}
                labelText={isMarkAsFinalAllowed ? "Final Version?" : "Preview"}
                subLabel=""
                // initIsDisabled={((reportingDetailsData.downloadId) ||
                //   (reportingDetailsData.permanentLocationFlag ||
                //     reportingDetailsData.edmStatus == 'SentToEDM' ||
                //     reportingDetailsData.edmStatus == 'SentToEdmTemp' ||
                //     reportingDetailsData.edmStatus == 'Failed Temp' ||
                //     reportingDetailsData.edmStatus == 'Failed')) ? true : false
                // }
                ariaLabelledBy="mark-final"
              /> : <div className="grid-title">Status</div>}</div>) : ''}
          </div>
          <div className="actionsHeaderG grid-title" >Actions</div>
        </div>
      )}

      {reportingDetailsData && reportingDetailsData.length > 0
        ? reportingDetailsData.map((item, index) => (
          <div
            className={'listContainer'}
            key={item.id}
            data-testid="file-container"
          >
            <div className="closebutton">
              <EDMSideModal
                modalTitle={'Preview'}
                handleModalClose={() => setIsOpenModal(false)}
                isOpen={isOpenModal && fileData}
              >
                <EDMDocumentViewer
                  file={fileData}
                  // handleDocChange={handleStatusUpdate}
                  toolbar={toolbar}
                // setDocLoadError={setDocLoadError}
                // docLoadError={docLoadError}
                ></EDMDocumentViewer>
              </EDMSideModal>

            </div>
            <div className={tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? "container-body" : "container-body-external"}>
              <div className="selectAllBodyG grid-body" style={!((reportingDetailsData[index].downloadId) && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) ? {
                pointerEvents: 'none',
                cursor: 'not-allowed',
                opacity: 0.5,
              } : {}}>
                <USBCheckbox
                  className='selectAllCheckBoxG'
                  handleChange={() => {
                    selectDownloadFile(
                      [item],
                      setActionsDrop,
                      getDocumentListingNoAPI,
                      setReportingDetailsData,
                      reportingDetailsData,
                      setLoading,
                      selectAll,
                      setSelectAll,
                      setDownloadEnabled,
                      count,
                      setCount,
                      index
                    );
                  }}
                  // initIsDisabled={
                  //   ((reportingDetailsData[index].downloadId) && (item.edmStatus !== 'SentToEDM' && item.edmStatus !== 'SentToEdmTemp' && item.edmStatus !== 'Failed Temp' && item.edmStatus !== 'Failed')) ? false : true
                  // }
                  initIsChecked={item.checked || getDownloadListsfromSessionStorage().includes(item.downloadId)}
                  ariaLabelledBy="mark-final"
                  labelText=""
                  subLabel=""
                />
              </div>
              <div className={tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? "fileNameBodyG grid-body" : "fileNameBodyG-external grid-body"} data-testid="doc-list">
                <strong>{tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? item.title : (item.title || item.name)}</strong>
                <br />
                <span>{item.size}</span>
              </div>
              {tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? (
                <div className="documentTitleBodyG grid-body" data-testid="doc-list">
                  <strong className="tooltip-on-hover version-name">
                    {item.fullName && item.fullName.length > 0 ? item.fullName : item.name}
                  </strong><br />
                  {item.fullName !== '' ? (
                    <div className="tooltip-name">{item.fullName}</div>
                  ) : (
                    ''
                  )}

                </div>
              ) : ''}
              {/* <div className="filehead filehead2">
                {item.versions.length > 0 ? (
                  <div
                    tabIndex="0"
                    className="fileopener"
                    onClick={() =>
                      toggleAccordion(
                        item.id,
                        openedAccordion,
                        setOpenedAccordion
                      )
                    }
                    onKeyDown={(event) =>
                      versionKeyDown(
                        event,
                        item.id,
                        openedAccordion,
                        setOpenedAccordion
                      )
                    }
                  >
                    {openedAccordion === item.id ? (
                      <span
                        aria-label="Hide uploaded files version history"
                        className="arrow-icon right-arrow"
                      />
                    ) : (
                      <span
                        aria-label="Show uploaded files version history"
                        className="arrow-icon down-arrow"
                      />
                    )}
                  </div>
                ) : (
                  <div className="fileopener hideinxs" />
                )}
              </div> */}
              <div className="uploadedOnBodyg grid-body">
                <strong>{item.uploadedDate}</strong>
                <br />
                <span>{item.uploadedTime}</span>
              </div>
              <div className="uploadedByBodyG grid-body">
                {item.uploadedByName}
                {item.uploadedByMail ? (
                  <span className="email-to-name">
                    <br />
                    <a
                      href={`mailto:${item.uploadedByMail}`}

                    >
                      {item.uploadedByMail}
                    </a>
                  </span>
                ) : (
                  ''
                )}
              </div>
              <div className="finalVersionBodyG grid-body">
                <div className='status-preview'>
                  {isMarkAsFinalAllowed ? tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? (
                    <div style={item.permanentLocationFlag ||
                      item.edmStatus == 'SentToEDM' ||
                      item.edmStatus == 'SentToEdmTemp' ||
                      item.edmStatus == 'Failed Temp' ||
                      item.edmStatus == 'Failed' ||
                      item.markedAsFinal == true ? {
                      pointerEvents: 'none',
                      cursor: 'not-allowed',
                      opacity: 0.5,
                    } : {}}>
                      {tempUserRole === 'employee' && !sessionStorage.getItem('remote_user') ? (<USBCheckbox
                        className='markAsFinalCheckBoxG'
                        id={item.id}
                        handleChange={(e) => {
                          markAsFinal(
                            item.id,
                            reportingDetailsData,
                            setActionsDrop,
                            getDocumentListing,
                            getDocumentListingNoAPI,
                            setReportingDetailsData,
                            item.renamedFlag,
                            setFailedFlag,
                            setMessageContent,
                            setSuccessFlag,
                            setLoading,
                            setIsDirty,
                            selectMarkfinal,
                            setSelectMarkfinal,
                            showWarning
                          )
                        }}
                        initIsChecked={item.MarkedasFinalValue || getFileListsfromSessionStorage().includes(item.id)}
                        labelText=""
                        subLabel=""
                        ariaLabelledBy="mark-final"
                      />) : ''}
                    </div>
                  ) : (
                    <div >
                      {item.MarkedasFinalValue ? (
                        <div className="statusIconG" aria-label="Document marked as final">
                          <img src={greenTick} />
                        </div>
                      ) : (
                        <>
                          <div className="statusIconG" aria-label="Document pending review">
                            <img src={greyCheck} />
                          </div>
                        </>
                      )}
                    </div>
                  ) : ""}
                  <div className="previewIconG">
                    {
                      <Link
                        to={location.pathname + location.search}
                        onClick={() => {
                          const nameExt = item.fullName
                            ? item.fullName?.split('.').pop()
                            : item.name?.split('.').pop();
                          nameExt != 'pdf'
                            // && (item.edmStatus !== 'Success EDM' && item.edmStatus !== 'Success FileNet' && item.edmStatus !== 'Success Temp')
                            ? alert('Only pdf document can be previewed')
                            : (item.edmStatus.includes('Success') === false) ?
                              alert("This document status is failed so could not be previewed")
                              : preview(
                                item.downloadId ? item.downloadId : item.id,
                                setLoading,
                                setActionsDrop
                              );
                        }}
                      >
                        <USBIconShow
                          colorVariant={
                            (item.fullName
                              ? item.fullName?.split('.').pop()
                              : item.name?.split('.').pop()) != 'pdf'
                              // && (item.edmStatus !== 'Success EDM' && item.edmStatus !== 'Success FileNet' && item.edmStatus !== 'Success Temp')
                              ? 'grey60'
                              : 'interaction'
                          }
                          title="Preview"
                          desc="Preview File"
                          ariaHidden={true}
                          id="add-icon"
                          focusable={true}
                          tabindex={-1}
                        />
                      </Link>
                    }
                  </div>
                </div>
                <br></br>
                <div className='statusTextG'>
                  {item.edmStatus == 'Failed Temp'
                    ? 'Failed'
                    : item.edmStatus == 'SentToEdmTemp'
                      ? 'Uploading'
                      : item.edmStatus == 'Success Temp' ||
                        item.edmStatus == 'Success'
                        ? 'Uploaded'
                        : item.edmStatus == 'Failed'
                          ? 'Failed'
                          : item.edmStatus == 'SentToEDM'
                            ? 'Finalizing'
                            : item.edmStatus == 'Success EDM' ||
                              item.edmStatus == 'Success FileNet' ||
                              item.edmStatus == 'Success'
                              ? 'Finalized'
                              : ''}
                </div>
              </div>
              <div className="actionBodyG grid-body" style={{ width: 10, paddingTop: 10 }}>
                <div className="action-dropdown">
                  <div
                    // style={{backgroundImage : `url('../../../assets/img/threedots.png')`}}
                    ref={renameFocus}
                    tabIndex="0"
                    role="listbox"
                    // className="threedots-drop"
                    data-testid="three-dots"
                    aria-label="Click for more options"
                    onClick={() =>
                      showActionsDropdown(
                        item.id,
                        actionsDrop,
                        setActionsDrop
                      )
                    }
                    onKeyDown={(event) =>
                      handleKeyDown(
                        event,
                        item.id,
                        actionsDrop,
                        setActionsDrop
                      )
                    }
                  >
                    <span className="threedots" aria-label="Actions">
                      <img src={threeDots} />
                    </span>
                  </div>
                  {actionsDrop === item.id ? (
                    <ul
                      data-testid="dot-list"
                      onKeyDown={(event) =>
                        threeDotKeyDown(event, setActionsDrop)
                      }
                    >
                      <li>
                        <button
                          type="button"
                          data-testid="download-file"
                          id="download"
                          className={
                            item.edmStatus == 'SentToEDM' ||
                              item.edmStatus == 'SentToEdmTemp' ||
                              item.edmStatus == 'Failed Temp' ||
                              item.edmStatus == 'Failed'
                              ? 'threedots-anchor disable-icon'
                              : 'threedots-anchor'
                          }
                          aria-label="download file"
                          onClick={() =>
                            downloadDocument(
                              item.downloadId,
                              setLoading,
                              setActionsDrop,
                              setFileDownload,
                              getDocumentListing,
                              setReportingDetailsData,
                              setMessageContent,
                              setFailedFlag
                            )
                          }
                        >
                          <span className="icon download" />
                          Download
                        </button>
                      </li>
                      {requirementResults.status === 'Completed' ? (
                        ''
                      ) : (
                        <li>
                          <button
                            type="button"
                            id="replace"
                            className={(requirementResults.category == "Wire Request" || requirementResults.category == "Invoice Request") && tempUserRole !== 'employee' ? 'threedots-anchor disable-icon' : 'threedots-anchor'}
                            aria-label="replace file"
                            onClick={() => {
                                item.legalHoldFlag === 'true'
                                ? confirmReplace(
                                  setErrorModal,
                                  setLegalHold,
                                  setErrorModalTxt,
                                  setErrorModalTitle
                                )
                                : ''
                            }
                            
                            }
                            onKeyDown={(e) =>
                              item.legalHoldFlag === 'true'
                                ? confirmReplace(
                                  setErrorModal,
                                  setLegalHold,
                                  setErrorModalTxt,
                                  setErrorModalTitle
                                )
                                : handleKeyDownReplace(e, replaceInputFile)
                            }
                          >
                            {item.legalHoldFlag === 'true'  || ((requirementResults.category == "Wire Request" || requirementResults.category == "Invoice Request") && tempUserRole !== 'employee') ? (
                              ''
                            ) : (
                              <input
                                data-testid="replace-file"
                                type="file"
                                tabIndex="-1"
                                aria-label="replace input"
                                ref={(input) => {
                                  // assigns a reference so we can trigger it later
                                  replaceInputFile = input;
                                }}
                                onChange={(e) =>
                                  replaceFile(
                                    e,
                                    item,
                                    setSuccessFlag,
                                    setFailedFlag,
                                    setMessageContent,
                                    setLoading,
                                    setActionsDrop,
                                    getDocumentListing,
                                    getDocumentListingNoAPI,
                                    setReportingDetailsData,
                                    reportingDetailsData,
                                    setSelectMarkfinal,
                                    setIsDirty,
                                    showWarning,
                                    requirementResults
                                  )
                                }
                                onKeyDown={(e) =>
                                  handleKeyDownReplace(e, replaceInputFile)
                                }
                                className="threedots-upload"
                              />
                            )}
                            <span className="icon upload" />
                            Replace
                          </button>
                        </li>
                      )}
                      {employee && !sessionStorage.getItem('remote_user') ? (
                        <li>
                          <button
                            type="button"
                            id="rename"
                            className={
                              item.permanentLocationFlag ||
                                item.edmStatus == 'SentToEDM' ||
                                item.edmStatus == 'SentToEdmTemp' ||
                                item.edmStatus == 'Failed Temp' ||
                                item.edmStatus == 'Failed'
                                ? 'threedots-anchor disable-icon'
                                : 'threedots-anchor'
                            }
                            onClick={() =>
                              editFileName(
                                item.id,
                                setLoading,
                                getDocumentListing,
                                getDocumentListingNoAPI,
                                setReportingDetailsData,
                                reportingDetailsData,
                                setCloseRenameModal,
                                setRenamedTextReceived,
                                setCurrentFilenetId,
                                renameFocus
                              )
                            }
                          >
                            <span className="icon rename" />
                            Edit
                          </button>
                        </li>
                      ) : (
                        ''
                      )}
                      {requirementResults.status === 'Completed' ? (
                        ''
                      ) : (
                        <li>
                          <button
                            type="button"
                            id="delete"
                            data-testid="delete-file"
                            className={
                              isDeleteAllowed == true
                                ? 'threedots-anchor'
                                : item.permanentLocationFlag ? 'threedots-anchor disable-icon' : 'threedots-anchor'
                            }
                            onClick={() =>
                              confirmDelete(
                                item,
                                setDeleteId,
                                setErrorModal,
                                setErrorModalTxt,
                                setErrorModalTitle,
                                setLegalHold,
                                setCount,
                                count,
                                setDownloadEnabled
                              )
                            }
                          >
                            <span className="icon delete" />
                            Delete
                          </button>
                        </li>
                      )}
                    </ul>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            {openedAccordion === item.id ? (
              <div className="listFrame">
                {item.versions.length > 0
                  ? item.versions.map((subitem) => (
                    <div className="listFrame childContainer">
                      <div className="fileheadsubmain">
                        <div className="filethumb">
                          <span className="document-img sub-img" />
                        </div>
                        <div className="fileheadsubdata">
                          <div className="filedtxt" data-testid="doc-list">
                            <div>
                              <strong className="tooltip-on-hover version-name">
                                {subitem.name ? subitem.name : ''}
                              </strong>
                              {subitem.fullName !== '' ? (
                                <div className="tooltip-name">
                                  {subitem.fullName ? subitem.fullName : ''}
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                            {subitem.versions.length == 0 ||
                              subitem.versions === null ||
                              !subitem.versions ? (
                              ''
                            ) : (
                              <div>
                                <span className="version-number">
                                  ({JSON.stringify(subitem.versions)})
                                </span>
                              </div>
                            )}
                            <br />
                            <span>{subitem.size ? subitem.size : ''}</span>
                          </div>
                        </div>
                      </div>
                      <div className="fileDate">
                        {subitem.uploadedDate ? subitem.uploadedDate : ''}
                        <br />
                        <span>
                          {subitem.uploadedTime ? subitem.uploadedTime : ''}
                        </span>
                      </div>
                      <div className="uploadedBy">
                        {subitem.uploadedByName
                          ? subitem.uploadedByName
                          : ''}
                        <br />
                        <span className="email-to">
                          {subitem.uploadedByMail
                            ? subitem.uploadedByMail
                            : ''}
                        </span>
                      </div>
                      <div />
                      <div className="action-sub-span">
                        <div className="action-dropdown">
                          <span
                            tabIndex="0"
                            data-testid="download-file"
                            id="download"
                            className="threedots-anchor version-download"
                            onClick={() =>
                              downloadDocument(
                                subitem.downloadId,
                                setLoading,
                                setActionsDrop,
                                setFileDownload,
                                getDocumentListing,
                                setReportingDetailsData,
                                setMessageContent,
                                setFailedFlag
                              )
                            }
                          >
                            <span className="icon download" />
                            Download
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                  : ''}
              </div>
            ) : (
              ''
            )}
          </div>
        ))
        : ''}
    </div>
  );
};

DocumentList.propTypes = {
  setLoading: PropTypes.func.isRequired,
  reportingDetailsData: PropTypes.any.isRequired,
  openedAccordion: PropTypes.number.isRequired,
  setOpenedAccordion: PropTypes.func.isRequired,
  employee: PropTypes.bool.isRequired,
  actionsDrop: PropTypes.string.isRequired,
  setActionsDrop: PropTypes.func.isRequired,
  getDocumentListing: PropTypes.func.isRequired,
  getDocumentListingNoAPI: PropTypes.func.isRequired,
  requirementResults: PropTypes.any.isRequired,
  setSuccessFlag: PropTypes.func.isRequired,
  setFailedFlag: PropTypes.func.isRequired,
  setMessageContent: PropTypes.func.isRequired,
  setDownloadEnabled: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  setCount: PropTypes.func.isRequired,
  setDeleteId: PropTypes.func.isRequired,
  setErrorModal: PropTypes.func.isRequired,
  setErrorModalTxt: PropTypes.func.isRequired,
  setErrorModalTitle: PropTypes.func.isRequired,
  setReportingDetailsData: PropTypes.func.isRequired,
  setCloseRenameModal: PropTypes.func.isRequired,
  setRenamedTextReceived: PropTypes.func.isRequired,
  setCurrentFilenetId: PropTypes.func.isRequired,
  setLegalHold: PropTypes.func.isRequired,
};

export default DocumentList;
